import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

const EMPTY = { current: "", next: "", confirm: "" };

export const ChangePassword = () => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (f.next !== f.confirm) return toast.error("Le due nuove password non coincidono");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Password aggiornata. Gli altri dispositivi sono stati disconnessi.");
      setF(EMPTY);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  const field = (k, id, label, ac) => (
    <div className="space-y-1.5">
      <Label htmlFor={id}>{label}</Label>
      <Input id={id} type="password" required minLength={k === "current" ? 1 : 8} value={f[k]} onChange={set(k)} autoComplete={ac} className="h-10 rounded-xl" data-testid={`change-pw-${k}-input`} />
    </div>
  );
  return (
    <div className="rounded-3xl border bg-white p-6" data-testid="change-password-card">
      <h3 className="font-medium flex items-center gap-2"><KeyRound className="h-4 w-4 text-[#1E3A8A]" /> Cambia password</h3>
      <form onSubmit={submit} className="mt-4 space-y-3 text-sm">
        {field("current", "pw-current", "Password attuale", "current-password")}
        {field("next", "pw-next", "Nuova password (almeno 8 caratteri)", "new-password")}
        {field("confirm", "pw-confirm", "Ripeti la nuova password", "new-password")}
        <Button type="submit" disabled={busy} className="rounded-full bg-[#1E3A8A] hover:bg-[#172f70]" data-testid="change-pw-submit">
          {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Aggiorna password
        </Button>
      </form>
    </div>
  );
};
